import React, { useEffect } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { useTranslation } from "react-i18next";

// PAGES
import Home from "./screens/home";
import CarsPage from "./screens/cars";
import CarDetails from "./screens/carsdetails";
import Contact from "./screens/Contact";
import LegalMentions from "./screens/LegalMentions";

const AnimRoutes: React.FC = () => {
  const location = useLocation();
  const { i18n } = useTranslation();

  const currentLanguage = i18n.language;
  const storedLanguage = localStorage.getItem("language");

  useEffect(() => {
    if (!storedLanguage) {
      localStorage.setItem("language", currentLanguage);
    }
  }, [currentLanguage, storedLanguage]);

  // ✅ On attend que l'animation de sortie soit terminée avant de changer la langue
  const handleExitComplete = () => {
    if (storedLanguage && storedLanguage !== currentLanguage) {
      i18n.changeLanguage(storedLanguage);
    }
  };

  return (
    <AnimatePresence mode="wait" onExitComplete={handleExitComplete}>
      <Routes location={location} key={location.pathname}>
        <Route
          path="/"
          element={<Navigate to={`/${currentLanguage}`} replace />}
        />
        <Route path={`/:lang`} element={<Home />} />
        <Route path={`/:lang/cars`} element={<CarsPage />} />
        <Route path={`/:lang/contact`} element={<Contact />} />
        <Route path={`/:lang/cars/:carId`} element={<CarDetails />} />
        <Route path={`/:lang/legal-mentions`} element={<LegalMentions />} />
        <Route
          path="*"
          element={<Navigate to={`/${currentLanguage}`} replace />}
        />
      </Routes>
    </AnimatePresence>
  );
};

export default AnimRoutes;
